import { render, staticRenderFns } from "./mr-echarts.vue?vue&type=template&id=0dbc135e&scoped=true"
import script from "./mr-echarts.vue?vue&type=script&lang=js"
export * from "./mr-echarts.vue?vue&type=script&lang=js"
import style0 from "./mr-echarts.vue?vue&type=style&index=0&id=0dbc135e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbc135e",
  null
  
)

export default component.exports